export default {
  title:"Warm Up",
  subsections:[
    require('./00_how_to_responde').default,
    require('./01_warmup').default
  ]
}



/** WEBPACK FOOTER **
 ** ./src/questions/00_warmup/index.js
 **/